// extracted by mini-css-extract-plugin
export var indeterminate = "_24-6";
export var md = "_24-5";
export var semantic = "_24-7";
export var sm = "_24-4";
export var text = "_24-8";
export var toggleControl = "_24-0";
export var toggleInput = "_24-1";
export var toggleSwitch = "_24-2";
export var xs = "_24-3";